<section id='login' class='background-10' ngClass.gt-xs='section-full' ngClass.lt-sm='section-mobile'>
    <div fxLayout='row' fxLayoutAlign='center center' >
    </div>
  </section>